import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Content from '../../components/layout/Content';
import BookableItemsEditor from './service-selection/BookableItemsEditor';
import TagsEditor from './service-selection/TagsEditor';

const ServicesCMS = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex items-center gap-4 mb-6'>
                    <Button variant='ghost' size='icon' onClick={() => navigate('/cms')}>
                        <ArrowLeft className='h-4 w-4' />
                    </Button>
                    <div>
                        <h1 className='text-3xl font-bold'>Buchbare Leistungen</h1>
                        <p className='text-muted-foreground'>
                            Verwalten Sie buchbare Leistungen, die in verschiedenen Bereichen der Anwendung verwendet werden.
                        </p>
                    </div>
                </div>

                <Tabs defaultValue='items' className='w-full'>
                    <TabsList className='mb-6'>
                        <TabsTrigger value='items'>Leistungen</TabsTrigger>
                        <TabsTrigger value='tags'>Tags</TabsTrigger>
                    </TabsList>
                    <TabsContent value='items'>
                        <BookableItemsEditor />
                    </TabsContent>
                    <TabsContent value='tags'>
                        <TagsEditor />
                    </TabsContent>
                </Tabs>
            </div>
        </Content>
    );
};

export default ServicesCMS;
